import { FaDownload } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import TopInfoBar from "../components/TopInfoBar";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TenderList() {

    const tenders = [
        {
            id: 7,
            subject: "Extension of E-Tender period for Concurrent Audit for the year 2026-27 (extended upto 27-08-2026 at 12:00 Noon)",
            ref: "NIT No. 04 of 2026-27 (Extension)",
            date: "25-08-2026",
            file: "/pdfs/eTender Notice_ADV_NIT.pdf",
            applyLink: "https://www.tenderwizard.com/eproc"
        },
        {
            id: 6,
            subject: "Extension of NIQ period for AMC of Cash Counting Fake Note Detection Machine and Bundle Counting Machine of various branches (19 nos.) (extended upto 11-08-2026 at 11.59 a.m.)",
            ref: "NIQ No. 02 of 2026-27 (Extension)",
            date: "05-08-2026",
            file: "/pdfs/NIQ_ADV_NIT 02 of 2026-27 DT 230726_period extension.pdf",
            applyLink: "https://murshidabaddccb.bank.in"
        },
        {
            id: 5,
            subject: "AMC for Cash Counting Fake Note Detection Machine and Bundle Counting Machine of various branches (19 nos.) for the period 01-08-2026 to 31-07-2027",
            ref: "NIQ No. 02 of 2026-27",
            date: "28-07-2026",
            file: "/pdfs/NIQ 02 of 26-27 DT 230726_SHORT.pdf",
            applyLink: "https://murshidabaddccb.bank.in"
        },
        {
            id: 4,
            subject: "Extension of E-Tender period for Supply, installation, testing and commissioning of B-Type Locker Room Door (SRD with grill gate and Air Ventilator) for Lalbagh Branch (extended upto 28-07-2026 at 11.59 a.m.)",
            ref: "NIT No. 03 of 2026-27 (Extension)",
            date: "23-07-2026",
            file: "/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_EXTENSION.pdf",
            applyLink: "https://www.tenderwizard.com/eproc"
        },
        {
            id: 3,
            subject: "Supply, installation, testing and commissioning of B-Type Locker Room Door (SRD with grill gate and Air Ventilator) for Lalbagh Branch (new building)",
            ref: "NIT No. 03 of 2026-27",
            date: "09-07-2026",
            file: "/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_SHORT.pdf",
            applyLink: "https://www.tenderwizard.com/eproc"
        },
        {
            id: 1,
            subject: "Supply of Computer & Networking Items",
            ref: "MDCCB/TDR/2025/01",
            date: "05-12-2025",
            file: "/tenders/computer-supply.pdf",
            applyLink: "https://murshidabaddccb.bank.in/apply-tender/1"
        },
        {
            id: 2,
            subject: "Security Service Tender",
            ref: "MDCCB/TDR/2025/02",
            date: "10-12-2025",
            file: "/tenders/security-service.pdf",
            applyLink: "https://murshidabaddccb.bank.in/apply-tender/2"
        }
        // আরও চাইলে এখানে add করো…
    ];

    const downloadFile = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = url.split("/").pop();
        link.click();
    };

    return (
        <>
            <div>
                <TopInfoBar />
                <Header />
                <Navbar />
            </div>
            <div className="max-w-7xl mx-auto px-4 py-10">

                <h2 className="text-3xl font-semibold mb-6">
                    Tender List Details
                </h2>

                <div className="bg-white shadow rounded-lg p-6">

                    {/* TABLE */}
                    <div className="overflow-x-auto">
                        <table className="w-full border rounded-lg text-sm">

                            <thead className="bg-blue-50 text-gray-700 font-semibold">
                                <tr>
                                    <th className="p-3 border">Subject/Topic</th>
                                    <th className="p-3 border">Reference Number</th>
                                    <th className="p-3 border">Publication Date</th>
                                    <th className="p-3 border">Download</th>
                                    <th className="p-3 border">Apply Tender</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tenders.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            className="text-center p-6 text-gray-500"
                                        >
                                            No tenders available right now.
                                        </td>
                                    </tr>
                                ) : (
                                    tenders.map((t) => (
                                        <tr key={t.id} className="border hover:bg-gray-50">

                                            <td className="p-3 border">{t.subject}</td>
                                            <td className="p-3 border text-center">{t.ref}</td>
                                            <td className="p-3 border text-center">{t.date}</td>

                                            {/* DOWNLOAD BUTTON */}
                                            <td className="p-3 border text-center">
                                                <button
                                                    onClick={() => downloadFile(t.file)}
                                                    className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2 mx-auto"
                                                >
                                                    <FaDownload /> Download
                                                </button>
                                            </td>

                                            {/* APPLY BUTTON */}
                                            <td className="p-3 border text-center">
                                                <a
                                                    href={t.applyLink}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 flex items-center gap-2 justify-center"
                                                >
                                                    Apply <FaArrowRight />
                                                </a>
                                            </td>

                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>

                </div>

            </div>
            <div>
                <Footer />
            </div>
        </>
    );
}
